/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { mcpEndpointsDelete } from "../funcs/mcpEndpointsDelete.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  DeleteMcpEndpointRequest,
  DeleteMcpEndpointSecurity,
} from "../models/operations/deletemcpendpoint.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type DeleteMcpEndpointMutationVariables = {
  request: DeleteMcpEndpointRequest;
  security?: DeleteMcpEndpointSecurity | undefined;
  options?: RequestOptions;
};

export type DeleteMcpEndpointMutationData = void;

export type DeleteMcpEndpointMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * deleteMcpEndpoint mcpEndpoints
 *
 * @remarks
 * Delete an MCP endpoint
 */
export function useDeleteMcpEndpointMutation(
  options?: MutationHookOptions<
    DeleteMcpEndpointMutationData,
    DeleteMcpEndpointMutationError,
    DeleteMcpEndpointMutationVariables
  >,
): UseMutationResult<
  DeleteMcpEndpointMutationData,
  DeleteMcpEndpointMutationError,
  DeleteMcpEndpointMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildDeleteMcpEndpointMutation(client, options),
    ...options,
  });
}

export function mutationKeyDeleteMcpEndpoint(): MutationKey {
  return ["@gram/client", "mcpEndpoints", "delete"];
}

export function buildDeleteMcpEndpointMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: DeleteMcpEndpointMutationVariables,
  ) => Promise<DeleteMcpEndpointMutationData>;
} {
  return {
    mutationKey: mutationKeyDeleteMcpEndpoint(),
    mutationFn: function deleteMcpEndpointMutationFn({
      request,
      security,
      options,
    }): Promise<DeleteMcpEndpointMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(mcpEndpointsDelete(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
